import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { cn } from "@/lib/utils";

export function MessageMarkdown({ className, content }: { className?: string; content: string }) {
  return (
    <div className={cn("text-sm leading-relaxed min-w-0 max-w-full break-words", className)}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          p: ({ children }) => <p className="whitespace-pre-wrap break-words">{children}</p>,
          a: ({ children, href }) => (
            <a
              href={href}
              target="_blank"
              rel="noreferrer"
              className="underline underline-offset-2 opacity-95 hover:opacity-100 break-all"
            >
              {children}
            </a>
          ),
          ul: ({ children }) => <ul className="list-disc pl-5 space-y-1">{children}</ul>,
          ol: ({ children }) => <ol className="list-decimal pl-5 space-y-1">{children}</ol>,
          li: ({ children }) => <li className="whitespace-pre-wrap break-words">{children}</li>,
          code: ({ children }) => (
            <code className="px-1.5 py-0.5 rounded bg-black/10 font-mono text-[0.9em]">{children}</code>
          ),
          pre: ({ children }) => (
            <pre className="mt-2 p-3 rounded-lg bg-black/10 overflow-x-auto max-w-full text-xs leading-relaxed">
              {children}
            </pre>
          ),
          blockquote: ({ children }) => (
            <blockquote className="border-l-2 border-current/20 pl-3 italic opacity-95">{children}</blockquote>
          ),
          hr: () => <hr className="my-3 border-current/15" />,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
